import regionCityBrowserDir from './cian.region-city-browser.dir';
import regionCityBrowserService from './cian.region-city-browser.service';

angular.module('cian.regionCityBrowser', [
  'cian.ui.button',
  'cian.filter'
])
  .config(["$interpolateProvider", function ($interpolateProvider) {
    $interpolateProvider.startSymbol('{$');
    $interpolateProvider.endSymbol('$}');
  }])
  .directive('regionCityBrowser', regionCityBrowserDir)
  .service('RegionCityBrowserService', regionCityBrowserService);



// WEBPACK FOOTER //
// ./src/components/region-city-browser/src/scripts/cian.region-city-browser.js